










































import {
  HasTaskMixin, Loader, ShowFinally, Message, formatDateTime,
} from 'mycorems-app-shared';
import repository from './client-subscriber-repository';
import {
  AccountSubscriber, AccountSubscriberFilters, QPagination, QueryResult,
} from '../../types';
import SubscriptionToggle from './SubscriptionToggle.vue';

interface Data {
  columns: object[],
  subscribers: AccountSubscriber[],
  pagination: QPagination,
}

export default HasTaskMixin.extend({
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      columns: [
        {
          name: 'name',
        },
        {
          name: 'subscribedAt',
          field: (subscriber: AccountSubscriber) => formatDateTime(subscriber.subscribedAt),
        },
        {
          name: 'actions',
        },
      ],
      subscribers: [],
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 5,
        page: 1,
      },
    };
  },
  watch: {
    userId(): void {
      this.load();
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    offset(): number {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage;
    },
    filters(): AccountSubscriberFilters {
      return {
        userId: this.userId,
        offset: this.offset,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    addMultiple(subscribers: AccountSubscriber[]): void {
      subscribers.forEach((subscriber: AccountSubscriber) => {
        this.subscribers.unshift(subscriber);
        this.pagination.rowsNumber += 1;
      });
    },
    load(): void {
      this.task = repository.findByUser(this.filters);
      this.task.then((result: QueryResult) => {
        this.subscribers = (result.items as AccountSubscriber[]);
        this.pagination.rowsNumber = result.total;
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    Loader,
    SubscriptionToggle,
    ShowFinally,
    Message,
  },
});
